<template>
    <div id="donut">
        <apexchart type="donut" height="260" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
export default {
  components: {
    apexchart: VueApexCharts,
  },
  name: 'Vue Chart',
  props: {
    X: Array,
    Y: Array,
    title: String
  },  
 data: function () {
  return {
   chartOptions: {
    dataLabels: {
        enabled: false
    },
    chart: {
      id: 'vuechart-example',
    },
    labels: this.X,
    legend: {
        position: 'left',
        offsetY: 20,
        height: 150,
    },
    title: {
        text: this.title,
        style: {
            fontSize: '16px'
        },
        offsetY: 5
    },
   },
   series: this.Y,
  }
 },
}
</script>
<style>
    #donut {
       border: 1px solid #AAA;
       border-radius: 7px;
       align-items: center;
       box-shadow: 0px 1px 22px -12px #607D8B;
       @media (max-width: 768px ){
      }
    }
</style>